import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const UserService = {
    getUserById: (id) => {
        return http.get(`${baseUrl}/cliami/users/${id}`);
    },

    getUsers: () => {
        return http.get(`${baseUrl}/cliami/users`);
    },

    saveUser: (user) => {
        if (!user.userId) {
            return http.post(`${baseUrl}/cliami/users/create`, user);
        } else {
            return http.put(`${baseUrl}/cliami/users/update/${user.userId}`, user);
        }
    },

    toggleDisableUser: (userId) => {
        return http.put(`${baseUrl}/cliami/users/toggle-disable/${userId}`);
    },

    forceUser2Init: (userId) => {
        return http.put(`${baseUrl}/cliami/users/force-password-change/${userId}`);
    },

    deleteUser: (userId) => {
        return http.delete(`${baseUrl}/cliami/users/${userId}`);
    },

    passwordUpdate: (data) => {
        return http.put(`${baseUrl}/cliami/users/password/update`, data);
    },
    getUsersTree: () => {
        return http.get(`${baseUrl}/cliami/users/tree`);
    },
};

export default UserService;
